import { render, staticRenderFns } from "./page-sidebar.vue?vue&type=template&id=03868bd2&scoped=true"
import script from "./page-sidebar.vue?vue&type=script&lang=js"
export * from "./page-sidebar.vue?vue&type=script&lang=js"
import style0 from "./page-sidebar.vue?vue&type=style&index=0&id=03868bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03868bd2",
  null
  
)

export default component.exports